import { CpDataApi } from 'cp-xhr';
import { EndpointMockDescription, MockOptions, setupMockResponses } from '@cp-shared-15/frontend-storybook-extensions';
import React from 'react';
import { SepaDownloadResponseData } from './ExampleData';
import { DefaultBusinessMarketApiError, DefaultBusinessMarketApiErrorCode } from '@cp-shared-15/common-utilities';
import { FinancialDetailsWithAllValues } from '../../../ExampleData';

const mockOptions: MockOptions<DefaultBusinessMarketApiErrorCode> = {
    Success: {
        status: 201,
        responseBody: SepaDownloadResponseData,
        delay: 1000,
    },
    'Business Error': DefaultBusinessMarketApiError,
    'Unexpected/Connection Error': {
        status: 500,
    },
};

export const SepaDownloadMock: EndpointMockDescription<DefaultBusinessMarketApiErrorCode> = {
    name: 'Sepa Download Response',
    method: 'get',
    defaultMockOption: 'Success',
    mockOptions,
    url: FinancialDetailsWithAllValues?._links?.downloadSepa || '',
};

function mockValidationResponse(): void {
    setupMockResponses(CpDataApi, [SepaDownloadMock]);
}

export const SepaDownloadResponseMockWrapper = (storyFn: () => React.ReactNode) => {
    mockValidationResponse();

    return <div>{storyFn()}</div>;
};
